/* window.BotSettings: оболочка собрана компонентом, контракт PAGES тот же (init, mount, fill, after, focusLanguage).
   Один экран: в серверном режиме тот же движок получает settingsServer вместо демо-данных. */
import { definePageModule } from '../../bridge/page-module';
import { Settings } from './Settings';
import { isServerMode } from '../../platform/server-mode';
import { createSettings } from './engine';
import { settingsServer } from './settings-server';

const SKIP = new Set(['markup', 'prepare', 'attach', 'init', 'unmount', 'S', 'fill', 'after', 'PREFIX', 'TESTS', 'mounted']);

export interface SettingsView {
  body: string;
  sheets: string;
}

export interface SettingsApi {
  prepare: () => SettingsView;
  attach: () => void;
  init: (o: BotPageUi) => void;
  unmount: () => void;
  fill: (...args: unknown[]) => void;
  after: () => void;
  S: object;
  PREFIX: string;
  TESTS: [string, [string, string][]][];
}

let api: SettingsApi;

/** Экран берёт api при отрисовке: installSettings уже вызван */
export function settingsApi() {
  return api;
}

/** Методы и геттеры раздела, кроме тех, что забирает контракт страницы */
function liveExtras(b: object): Record<string, unknown> {
  const extra: Record<string, unknown> = {};
  for (const [k, d] of Object.entries(Object.getOwnPropertyDescriptors(b))) {
    if (SKIP.has(k)) continue;
    if (d.get) Object.defineProperty(extra, k, { enumerable: true, get: () => (b as Record<string, unknown>)[k] });
    else if (typeof d.value === 'function') {
      const fn = d.value as (...args: unknown[]) => unknown;
      extra[k] = (...args: unknown[]) => fn.apply(b, args);
    } else extra[k] = d.value;
  }
  return extra;
}

export function installSettings() {
  const server = isServerMode();
  const b = createSettings() as unknown as SettingsApi;
  if (server) b.init({ server: settingsServer } as unknown as BotPageUi);
  api = b;
  definePageModule({
    global: 'BotSettings',
    PREFIX: b.PREFIX,
    TESTS: server ? [] : b.TESTS,
    S: b.S,
    Page: Settings,
    init(o) {
      b.init(o);
    },
    fill(...args: unknown[]) {
      if (!server) b.fill(...args);
    },
    after() {
      b.after();
    },
    beforeUnmount() {
      b.unmount();
    },
    extra: liveExtras(b),
  });
}
